/* eslint-disable react/prop-types */
import React from 'react';
import { useFormikContext } from 'formik';

import Button from '@components/form/Button';

function SociollaSubmitButton(props) {
  const { handleSubmit } = useFormikContext();
  if (props.onPress) {
    return (
      <Button
        {...props}
        onPress={async () => {
          await props.onPress();
          handleSubmit();
        }}
      />
    );
  } else {
    return <Button {...props} onPress={handleSubmit} />;
  }
}

export default SociollaSubmitButton;
